import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
//import Login from './LoginForm/form';
import Quiz from './SignupQuiz/quiz';
//import VerifyCompany from './SignupVerification/verify';
import Home from './Web/home';
import Contact from './Web/contact'
import About from './Web/about';
import Formula from './Web/formula';
import AboutFormula from './Web/aboutformula';
import BlogIndex from './Web/blog';
import News from './Web/news';
import SearchPage from './Search/search';
import NotFound from './Web/404';
import SignIn from './Web/signin';
import ProtectedRoute from './contexts/ProtectedRoute';
import DashboardLayout from './dashboard/layout';
import { AuthProvider } from './contexts/AuthContext';
import Settings from './dashboard/pages/settings';
import GettingStarted from './dashboard/pages/gettingstarted';
import AboutDash from './dashboard/pages/about';
import EducationCenter from './dashboard/ComingSoon/EducationCenter';
//import Store from './dashboard/pages/store';
import FAQ from './dashboard/pages/faq';
import NewsDash from './dashboard/pages/news';
import InstallGuide from './dashboard/pages/installguide';
import Reset from './Web/reset';
import ContactDash from './dashboard/pages/contact';
import WhyIFLO from './Web/whyiflo';
import StoreComingSoon from './dashboard/ComingSoon/Store';
import Clarity from '@microsoft/clarity';
import LogRocket from 'logrocket';
import VideoBook from './Web/videobook';
LogRocket.init('auu6rx/iflo-pros');



function App() {
  
const projectId = "quxu5r0p4n"

Clarity.init(projectId);


  return (
    <div className="App">
      <AuthProvider>
        <Routes>
          {/* Define routes for Login and Signup */}
          {/*<Route path="/login" element={<Login />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/about-formula" element={<AboutFormula />} />
          <Route path="/ingredients" element={<Formula />} />
          <Route path="/signup" element={<Quiz />} />
          <Route path="/about" element={<About />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/request-materials" element={<VideoBook />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
          <Route path="/news" element={<News />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/password-reset" element={<Reset />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/why-iflo" element={<WhyIFLO />} />
          {/* Redirect to /login if no valid route is found */}
          {/*<Route path="*" element={<Navigate to="/signup" replace />} />*/}
          <Route path="/dashboard/*" element={
            <ProtectedRoute>
              <DashboardLayout>
                <Routes>
                  <Route index element={<GettingStarted />} />
                  <Route path="about" element={<AboutDash />} />
                  <Route path="install" element={<InstallGuide />} />
                  <Route path="faqs" element={<FAQ />} />
                  <Route path="news" element={<NewsDash />} />
                  <Route path="education" element={<EducationCenter />} />
                  <Route path="store" element={<StoreComingSoon />} />
                  <Route path="account" element={<Settings />} />
                  <Route path="contact" element={<ContactDash />} />
                </Routes>
              </DashboardLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
